<template>
  <div class="uploader-list">
    <ul>
      <li v-for="file in uploadFiles" :key="file.id">
        <div status="success" class="uploader-file">
          <div
            class="uploader-file-progress"
            style="transform: translateX(0%);"
            :class="{ error: file.error }"
          ></div>
          <div class="uploader-file-info">
            <div class="uploader-file-name">
              <i class="uploader-file-icon" icon="document"></i>
              {{ file.name }}
            </div>
            <div class="uploader-file-size"></div>
            <div class="uploader-file-status" :title="file.errMsg">
              {{ getElpsMsg(file.errMsg) }}
            </div>
            <div class="uploader-file-actions" v-if="!disabled">
              <i
                class="el-icon-download"
                @click="download(file)"
                title="下载"
                v-if="!file.error"
              ></i>
              <span
                class="uploader-file-remove"
                @click="remove(file)"
                title="移除"
              ></span>
            </div>
          </div>
        </div>
      </li>
    </ul>

    <ul>
      <li v-for="(file, index) in fileList" :key="file.id + index">
        <uploader-file
          :file="file"
          :list="true"
          :disabled="disabled"
          :skipCallback="options && options.skipCallback"
          @real-file-success="handleRealFileSuccess"
          @upload-error="handleUploadError"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import UploaderFile from "./file.vue";
import { getEllipsisString } from "../../helpers/common";

export default {
  name: "uploader-list",
  components: {
    UploaderFile
  },
  data() {
    return {
      uploadFiles: []
    };
  },
  watch: {
    uploadedFiles: {
      handler(newValue) {
        this.uploadFiles = newValue;
      },
      immediate: true,
      deep: true
    }
  },
  props: {
    options: Object,
    disabled: {
      type: Boolean,
      default: false
    },
    uploadedFiles: {
      type: Array,
      default: () => []
    },
    fileList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleRealFileSuccess() {
      this.$emit("real-file-success");
    },
    handleUploadError(e) {
      this.$emit("upload-error", e);
    },
    getElpsMsg(msg) {
      return msg ? getEllipsisString(msg, 10) : "已上传";
    },
    download(file) {
      this.$axios({
        url: `/annotate/fcs/downloadFile?fileId=${file.id}`,
        responseType: "arraybuffer"
      });
    },
    remove(file) {
      const index = this.uploadFiles.findIndex(o => o.id === file.id);
      this.uploadFiles.splice(index, 1);
      this.$emit("remove-file", file);
    }
  }
};
</script>
<style scoped>
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}
.error {
  background: #ffe0e0;
}
.uploader-file {
  min-width: 495px;
}
</style>
